import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PropertiesSettings } from '../../core/configuration/properties-settings';
import { HelpersService } from '../../core/services/helpers.service';
import { OperationsService } from '../../core/services/operations.service';
import { EsitoSpedizioneAdapter } from '../components/fascicolo/lettere-diffida-update/esito-spedizione-adapter';
import { EsitoSpedizioneDiffida } from '../models/esito-spedizione-diffida';
import { MotivoEsitoSpedizione } from '../models/tipologiche/motivo-esito-spedizione';
import { TipoEsitoSpedizione } from '../models/tipologiche/tipo-esito-spedizione';
import { BaseForm } from './base-Form';

declare var removeEmptyObject: any;

export abstract class LettereDiffidaEsitoSpedizioneForm extends BaseForm {

  tipiEsitoSpedizione: TipoEsitoSpedizione[] = [];
  motiviEsitoSpedizione: MotivoEsitoSpedizione[] = [];
  esitoSpedizione: EsitoSpedizioneDiffida;
  esitoSpedizioneForm: FormGroup;
  idTipoEsitoSpedizioneNegativo = PropertiesSettings.ID_TIPO_ESITO_SPEDIZIONE_NEGATIVO;

  constructor(private helpers: HelpersService, protected operationsService: OperationsService, private formBuilder: FormBuilder) {
    super();
  }

  createForm() {
    this.esitoSpedizione = EsitoSpedizioneAdapter.clonEsitoSpedizione(this.getEsitoSpedizioneLetteraDiffida());
    this.esitoSpedizioneForm = this.formBuilder.group({
      tipoEsitoSpedizione: [this.esitoSpedizione.tipoEsitoSpedizione, Validators.required],
      motivoEsitoSpedizione: [this.esitoSpedizione.motivoEsitoSpedizione],
      dataSpedizione: [this.esitoSpedizione.dataSpedizione, Validators.required],
      note: [this.esitoSpedizione.note],
    });
  }

  populateSelect() {
    if (this.tipiEsitoSpedizione.length === 0) {
      this.helpers.getTipiEsitoSpedizione().subscribe(response => this.tipiEsitoSpedizione = response);
    }

    if (this.motiviEsitoSpedizione.length === 0) {
      this.helpers.getMotiviEsitoSpedizione().subscribe(response => this.motiviEsitoSpedizione = response);
    }

  }

  update() {
    this.getRequest(this.esitoSpedizione);
  }

  gestisciNuovoTipoEsito(tipoEsitoSpedizione: TipoEsitoSpedizione) {
    this.esitoSpedizione.tipoEsitoSpedizione = tipoEsitoSpedizione;
    this.esitoSpedizione.motivoEsitoSpedizione = undefined;
  }

  abstract getRequest(esitoSpedizione: EsitoSpedizioneDiffida);
  abstract getEsitoSpedizioneLetteraDiffida(): EsitoSpedizioneDiffida;
}
